import { GENERIC_LIST } from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import ListModule from './index';
import GenericListThunk from './thunk';

const module: ModulesList = {
  [GENERIC_LIST]: {
    path: '/:module/list',
    component: ListModule,
    thunk: GenericListThunk,
  },
};

export default module;
